
import { config } from "@/config";

/**
 * Translates a text to multiple target languages using Google Translate API
 * @param text The text to translate
 * @param targetLanguages Array of target language codes
 * @returns Object with translations keyed by language code
 */
export async function translateComment(
  text: string,
  targetLanguages: string[] = ['en', 'zh-TW', 'zh-CN']
): Promise<Record<string, string>> {
  if (!text || text.trim() === '') {
    return {};
  }

  const translationData: Record<string, string> = {};
  const googleTranslateUrl = "https://translation.googleapis.com/language/translate/v2";
  const apiKey = config.googleApiKey;

  try {
    // Execute translation requests for each target language
    for (const target of targetLanguages) {
      const response = await fetch(`${googleTranslateUrl}?key=${apiKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          q: text,
          target: target,
          format: 'text',
        }),
      });
      
      if (!response.ok) {
        console.error(`Translation to ${target} failed:`, await response.text());
        continue;
      }
      
      const data = await response.json();
      
      if (data.data && data.data.translations && data.data.translations.length > 0) {
        translationData[target] = data.data.translations[0].translatedText;
      }
    }

    console.log("Translations completed:", Object.keys(translationData));
    return translationData;
  } catch (error) {
    console.error("Error translating text:", error);
    return {};
  }
}
